import { deriveSharedSecret } from './deriveSharedSecret';
import { deriveSharedSecretHint } from './deriveSharedSecretHint';

/**
 * Checks if the given sharedSecretHint matches the derived hint from the
 * receiver's secret key and the sender's ephemeral public key.
 *
 * @param opts.ephemeralPublicKey - Sender's ephemeral X25519 public key (32 bytes)
 * @param opts.sharedSecretHint - 2-byte hint sent alongside the push message
 * @param opts.receiverPrivateKey - Receiver's private X25519 key
 */
export function matchesSharedSecretHint(opts: {
  ephemeralPublicKey: Uint8Array;
  sharedSecretHint: Uint8Array;
  receiverPrivateKey: Uint8Array;
}): boolean {
  if (opts.ephemeralPublicKey.length !== 32 || opts.sharedSecretHint.length !== 2) {
    return false;
  }

  const sharedSecret = deriveSharedSecret(
    opts.receiverPrivateKey,
    opts.ephemeralPublicKey,
  );

  // Typically, the hint is derived as the first 2 bytes of a hash of the shared secret
  const expectedHint = deriveSharedSecretHint(sharedSecret);

  return (
    expectedHint[0] === opts.sharedSecretHint[0] &&
    expectedHint[1] === opts.sharedSecretHint[1]
  );
}